import { CONSULTATION_STATUS, CONSULTATION_STEPS } from '@/types/consultation'

export enum WebSocketState {
  CONNECTING = 0,
  OPEN = 1,
  CLOSING = 2,
  CLOSED = 3
}

export const CASE_STATUS_STEP: Record<CONSULTATION_STATUS, CONSULTATION_STEPS> = {
  [CONSULTATION_STATUS.OPEN]: CONSULTATION_STEPS.MATCHING,
  [CONSULTATION_STATUS.CLAIMED]: CONSULTATION_STEPS.MATCH,
  [CONSULTATION_STATUS.RESOLVED]: CONSULTATION_STEPS.ANSWER,
  [CONSULTATION_STATUS.WAITING_FOR_RATING]: CONSULTATION_STEPS.ANSWER,
  [CONSULTATION_STATUS.CANCELED]: CONSULTATION_STEPS.LANDING,
  [CONSULTATION_STATUS.CLOSED]: CONSULTATION_STEPS.ANSWER,
  [CONSULTATION_STATUS.NEW]: CONSULTATION_STEPS.LANDING,
  [CONSULTATION_STATUS.CLOSED_WORATING]: CONSULTATION_STEPS.LANDING
}
